import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/QnA/components/QnAContainer.tsx");
